var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".circle_remove{fill:#5c9dff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "circle_remove",
    d: "M8,0a8,8,0,1,0,8,8A8.024,8.024,0,0,0,8,0Zm3.5,10.1-1.4,1.4L8,9.4,5.9,11.5,4.5,10.1,6.6,8,4.5,5.9,5.9,4.5,8,6.6l2.1-2.1,1.4,1.4L9.4,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRemove);
export default __webpack_public_path__ + "static/media/circle-remove.633cc952d7b4eefd8abae42e295c479c.svg";
export { ForwardRef as ReactComponent };